<template>
  <Field
    ref="field"
    :name="fieldName"
    :rules="rules"
    v-bind="fieldProps"
    v-slot="{ field, errors, meta, value, validate }"
  >
    <slot
      v-bind="field"
      :errors="errors"
      :value="value"
      :validate="validate"
      :valid="meta.valid"
      :invalid="meta.valid === false"
      :pending="meta.pending"
      :flags="{
        valid: meta.valid,
        invalid: meta.valid === false,
        pending: meta.pending,
      }"
      :field="field"
    >
    </slot>
  </Field>
</template>
<script>
import { Field } from "vee-validate";

let fieldId = 0;

export default {
  name: "ValidationProvider",
  components: { Field },
  props: {
    rules: { type: [String, Object], default: "" },
    name: { type: String, default: "" },
    vid: { type: String, default: "" },
    // vee-validate 3 inferred the value from the child's v-model. v4's Field
    // needs it passed explicitly (also covers prefilled values in edit forms),
    // otherwise rules like `required` always fail. Callers pass `:value="form.x"`.
    value: { type: null, default: undefined },
    modelValue: { type: null, default: undefined },
  },
  data() {
    return {
      fieldName: this.name || this.vid || `_vp_${++fieldId}`,
    };
  },
  computed: {
    fieldProps() {
      const value =
        this.modelValue !== undefined ? this.modelValue : this.value;
      return value === undefined ? {} : { modelValue: value };
    },
  },
  methods: {
    async validate() {
      if (this.$refs.field && typeof this.$refs.field.validate === "function") {
        return this.$refs.field.validate();
      }
    },
    async reset() {
      if (this.$refs.field && typeof this.$refs.field.reset === "function") {
        return this.$refs.field.reset();
      }
    },
  },
  watch: {
    name(val) {
      if (val) this.fieldName = val;
    },
    vid(val) {
      if (val && !this.name) this.fieldName = val;
    },
  },
};
</script>
